import axios from "axios";

axios.defaults.baseURL = "https://backend.neuromedclinics.com/api";
// axios.defaults.baseURL = "https://study-backend.developnetwork.net/api";



export default axios;


